import React from 'react'
import Img from 'gatsby-image'
import { s, globals, colors, alpha } from '../../style'
import { T } from '../../typo'

const IntroPage = ({
  title,
  subtitle,
  description,
  descriptionList,
  image,
  theme,
}) => {
  return (
    <section css={[sSection, { contentVisibility: 'auto' }]}>
      <div css={sParalaxContainer}>
        {image?.childImageSharp?.fluid ? (
          <Img
            style={sImageContainer}
            fluid={image.childImageSharp.fluid}
            alt={image.name}
          />
        ) : (
          <div css={sNoImage} />
        )}
        <div css={sGradient(theme)} />
      </div>
      <div css={sTextContainer}>
        <T
          xs={40}
          sm={64}
          md={72}
          lg={96}
          xl={96}
          center
          bold
          upper
          variant="h1"
          extraCss={[
            sTextContainer.title,
            sTextGardient(theme).title,
            subtitle
              ? {
                  [s.sm_down]: {
                    marginTop: `calc(50vh - ${globals.menu.height.mobile}px)`,
                  },
                  [s.md]: {
                    marginTop: `calc(50vh - ${globals.menu.height.desktop}px)`,
                  },
                }
              : {
                  [s.sm_down]: {
                    marginTop: `calc(50vh - ${
                      globals.menu.height.mobile / 2
                    }px)`,
                  },
                  [s.md]: {
                    marginTop: `calc(50vh - ${
                      globals.menu.height.desktop / 2
                    }px)`,
                  },
                },
          ]}>
          {title}
        </T>
        <T
          xs={20}
          sm={24}
          md={28}
          lg={32}
          xl={32}
          center
          upper
          bold
          spacious
          variant="h2"
          extraCss={[sTextContainer.subtitle, sTextGardient(theme).subtitle]}>
          {subtitle}
        </T>
        {description && (
          <T
            m={14}
            t={16}
            d={18}
            center
            bold
            variant="body1"
            extraCss={[
              sTextContainer.description,
              sTextGardient(theme).description,
            ]}>
            {description}
          </T>
        )}
        {descriptionList &&
          descriptionList
            .filter((_, id) => id === 0)
            .map(({ text }, id) => (
              <T
                key={id}
                m={14}
                t={16}
                d={18}
                center
                bold
                variant="body1"
                extraCss={[
                  sTextContainer.description,
                  sTextGardient(theme).description,
                ]}>
                {text}
              </T>
            ))}
      </div>
    </section>
  )
}

const sSection = {
  position: 'relative',
  width: '100vw',
  [s.sm_down]: {
    height: '100vh',
  },
  [s.md]: {
    // height: `calc(50vh + ${globals.menu.height.desktop}px)`,
    height: '100vh',
  },
  top: -globals.menu.height.desktop,
}

const absolute100 = {
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
}

const sParalaxContainer = {
  ...absolute100,
  zIndex: -1,
}
const sImageContainer = {
  ...absolute100,
  objectPosition: 'center center',
  // height: '100vh',
  // top: '50%',
  // transform: 'translateY(-50%)',
  // objectFit: 'cover',
}
const sNoImage = {
  ...absolute100,
}

const sGradient = (theme) => ({
  ...absolute100,
  background: `linear-gradient(${colors[theme].background[0].concat(
    alpha[60]
  )}, ${colors[theme].background[1].concat(alpha[60])}, ${colors[
    theme
  ].background[1].concat(alpha[100])})`,
})

const sTextContainer = {
  display: 'flex',
  // justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  // height: '100%',
  flexDirection: 'column',

  title: {
    lineHeight: '1em',
    width: '90%',
    letterSpacing: 0.1 + 'em',
  },
  subtitle: {
    lineHeight: '1.4em',
    width: '75%',
    [s.sm_down]: {
      marginTop: '4rem',
    },
    [s.md]: { width: '50%', marginTop: '4rem' },
  },
  description: {
    [s.sm_down]: {
      marginTop: '4rem',
      width: '75%',
    },
    [s.md]: { marginTop: '4rem', width: '50%' },
  },
}

const sTextGardient = (theme) => ({
  title: {
    background: `linear-gradient(45deg, ${colors[theme].mainLighter.concat(
      alpha[100]
    )}, ${colors[theme].mainDarker.concat(alpha[100])})`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  subtitle: {
    background: `linear-gradient(45deg, ${colors[theme].main.concat(
      alpha[100]
    )}, ${colors[theme].mainDarker.concat(alpha[100])})`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
  description: {
    background: `linear-gradient(45deg, ${colors[theme].text.concat(
      alpha[60]
    )}, ${colors[theme].text.concat(alpha[30])})`,
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },
})

export default IntroPage
